import { render, staticRenderFns } from "./login-formulario.html?vue&type=template&id=000fc326&scoped=true&"
import script from "./login-formulario.vue?vue&type=script&lang=ts&"
export * from "./login-formulario.vue?vue&type=script&lang=ts&"
import style0 from "./login-formulario.vue?vue&type=style&index=0&id=000fc326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000fc326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
